/**
 * @class ButtonBase
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import GetStyledButtonBase from './ButtonBase.styles'

export default class ButtonBase extends Component {
  static propTypes = {
    component: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    type: PropTypes.string
  }

  static defaultProps = {
    type: 'button'
  }

  render() {
    const { children, disabled, component, type, ...other } = this.props

    let ComponentProp = component
    const buttonProps = {}

    if (!ComponentProp) {
      if (other.href) {
        ComponentProp = 'a'
      } else {
        ComponentProp = 'button'
      }
    }

    if (ComponentProp === 'button') {
      buttonProps.type = type
      buttonProps.disabled = disabled
    } else {
      buttonProps.role = 'button'
    }

    const StyledComponent = GetStyledButtonBase(ComponentProp)

    return (
      <StyledComponent disabled={disabled} {...buttonProps} {...other}>
        {children}
      </StyledComponent>
    )
  }
}
